import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ExternalSvgModule } from '@ui-lib';

import {
  credentialsInterceptor,
  xsrfInterceptor,
  API_URL,
  SERVER_API_URL,
  PORTAL_ROLE,
  AuthenticationService,
  LocalStorageService,
  NavigationService,
  NAVIGATION_CONFIG,
  jwtInterceptor,
  RefreshTokenStateService,
  UserService,
  ProviderService,
  AdminPatientsService,
  AdminPatientExportService,
  DIRECTORY_PORTAL_URL,
  GoogleMapsLoaderService,
  provideAuthBootstrap,
  provideGoogleMapsApi,
  PORTAL_HEADER_COMPONENT,
  PORTAL_SIDEBAR_COMPONENT,
} from '@services';

import { provideQuillConfig } from 'ngx-quill/config';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { NavigationConfig } from './navigation.config';
import { provideGoogleClientId } from '../../../services/src/lib/services/google-client-id.provider';
import { provideZoomClientId } from '../../../services/src/lib/services/zoom-client-id.provider';
import {
  provideMicrosoftClientId,
  provideMicrosoftTenantId,
} from '../../../services/src/lib/services/microsoft-client-id.provider';
import { AdminPortalHeaderComponent } from './main/shell/portal-header/portal-header.component';
import { AdminPortalSidebarMenuComponent } from './main/shell/sidebar-menu/admin-portal-sidebar-menu.component';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    provideHttpClient(
      withInterceptors([
        credentialsInterceptor,
        jwtInterceptor,
        xsrfInterceptor,
      ])
    ),
    provideAnimationsAsync(),
    importProvidersFrom(ExternalSvgModule),
    provideAuthBootstrap(),

    {
      provide: PORTAL_HEADER_COMPONENT,
      useValue: AdminPortalHeaderComponent,
    },
    {
      provide: PORTAL_SIDEBAR_COMPONENT,
      useValue: AdminPortalSidebarMenuComponent,
    },
    { provide: API_URL, useValue: environment.apiRootUrl },
    {
      provide: SERVER_API_URL,
      useValue: environment.serverApiRootUrl || environment.apiRootUrl,
    },
    { provide: PORTAL_ROLE, useValue: environment.role },
    { provide: DIRECTORY_PORTAL_URL, useValue: environment.directoryPortalUrl },
    { provide: NAVIGATION_CONFIG, useValue: NavigationConfig },

    NavigationService,
    AuthenticationService,
    LocalStorageService,
    RefreshTokenStateService,

    UserService,
    ProviderService,
    AdminPatientsService,
    AdminPatientExportService,
    GoogleMapsLoaderService,

    provideGoogleMapsApi(environment.googleMapsApiKey || ''),
    provideGoogleClientId(environment.googleOauthClientId || ''),
    provideZoomClientId(environment.zoomOauthClientId || ''),
    provideMicrosoftClientId(environment.microsoftOauthClientId || ''),
    provideMicrosoftTenantId(environment.microsoftOauthTenantId || ''),

    provideQuillConfig({
      modules: {
        syntax: true,
      },
    }),
  ],
};
